import React, { useEffect, useState } from "react";

import {
  Row,
  Typography,
  Col,
  Spin,
  Avatar,
  Card,
  Form,
  Tag,
  InputNumber,
  Modal,
  Input,
  Button,
} from "antd";

import { FONT } from "constants/index";

import { ColumnsChart } from "./columns-table";
import { ArrowUpFromLine, ChartBar, CircleAlert, UserRound } from "lucide-react";
import { chartBar } from "../reviews/reviews-drawer-charts";
import DrawerApp from "components/drawer-app";
import { updateTraining } from "services/planning/planning-service";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import FormLoadUserComparation from "../load-control/load-control-drawer-comparation";
import useBreakpoint from "hooks/useBreakpoint";
import { drawerWidth } from "util/responsive";
import ResponsiveDataList from "components/responsive-data-list";

const { Text } = Typography;
const { Meta } = Card;
const { info } = Modal;
const { TextArea } = Input;
const ManagerialChart = (props) => {
  const { isMobile, isDesktop } = useBreakpoint();
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState([]);
  const [planTraining, setPlanTraning] = useState(null);
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);
  const [formUser] = Form.useForm();
  const [formAnnotation] = Form.useForm();
  const [openComparation, setOpenComparation] = useState(false);

  useEffect(() => {
    setLoadingData(true);

    const planTraining = props.user?.planningTrainings?.filter(
      (pt) => pt.planningType == "BACK_SQUAD"
    );

    if (planTraining != undefined) {
      let dataPlanning = planTraining[0]?.allTrainings ?? [];
      dataPlanning = dataPlanning.map((obj) => ({
        ...obj,
        edit: edit,
        openAnotation: openAnotation,
      }));
      setData(dataPlanning);
      setPlanTraning(planTraining[0]);
    }

    setLoadingData(false);
  }, [props]);

  function edit(row) {
    setEditId(row);
    showDrawer();
  }
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setEditId(null);
    setOpen(false);
  };

  const onCloseComparation = () => {
    setOpenComparation(false);
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const weekLabel = payload[0]?.payload?.week
        ? `Semana ${payload[0].payload.week}`
        : label;
      const diferenca = payload[1]?.value - payload[0]?.value;
      const percentual = (diferenca / payload[1]?.value) * 100;
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontFamily: FONT,
          }}
        >
          <p className="intro">{weekLabel}</p>
          <p className="intro">
            VMP Esperada:{" "}
            <span style={{ color: "#14B8A6" }}>{payload[0]?.value}</span>
          </p>
          {payload[1]?.value && (
            <p className="intro">
              VMP Atual:{" "}
              <span style={{ color: "#3B82F6" }}>{payload[1]?.value}</span>
            </p>
          )}

          {payload[1]?.value && (
            <p className="intro">
              Comparativo:{" "}
              <span style={{ color: percentual > 0 ? "#14B8A6" : "#EC6D62" }}>
                {percentual.toFixed(2)}%
              </span>
            </p>
          )}
        </div>
      );
    }

    return null;
  };

  function getWeek(trainings) {
    const week = trainings?.load;
    const type = trainings?.orderTraining;

    if (week) {
      const typeTraining = type % 2 === 0 ? "B" : "A";
      const color = type % 2 === 0 ? "geekblue" : "green";

      return (
        <div>
          Semana {week} -{" "}
          <Tag color={color} key={typeTraining}>
            {typeTraining.toUpperCase()}
          </Tag>
        </div>
      );
    }
    return "Cíclo Finalizado";
  }

  const DescriptionItem = ({ title }) => (
    <div
      className="site-description-item-profile-wrapper"
      style={{ fontFamily: FONT, fontSize: 16 }}
    >
      <b>{title}</b>
    </div>
  );

  const CardTraining = ({ row }) => {
    formUser.setFieldValue("vmp1", row?.vmp1);
    formUser.setFieldValue("vmp2", row?.vmp2);
    formUser.setFieldValue("vmp3", row?.vmp3);
    formUser.setFieldValue("vmp4", row?.vmp4);

    return (
      <Col key={row?.id} span={24}>
        <Card
          style={{
            width: "100%",
            marginBottom: 16,
            minHeight: 300,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Meta
            title={<div>{getWeek(row)}</div>}
            description={
              <div>
                <Row>
                  <Col span={24}>
                    <DescriptionItem title={"Exercício Agachamento"} />
                  </Col>
                </Row>

                <Row style={{ marginTop: 40 }}>
                  <Col span={24}>
                    <DescriptionItem title={"VMP Agachamento"} />
                  </Col>
                </Row>

                <Form form={formUser} layout="vertical">
                  <Row gutter={16}>
                    <Col xs={12} sm={6}>
                      <Form.Item name="vmp1" label={<span style={{ fontFamily: FONT }}>VMP 1</span>}>
                        <InputNumber
                          decimalSeparator=","
                          style={{ fontFamily: FONT, width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                      <Form.Item name="vmp2" label={<span style={{ fontFamily: FONT }}>VMP 2</span>}>
                        <InputNumber
                          decimalSeparator=","
                          style={{ fontFamily: FONT, width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                      <Form.Item name="vmp3" label={<span style={{ fontFamily: FONT }}>VMP 3</span>}>
                        <InputNumber
                          decimalSeparator=","
                          style={{ fontFamily: FONT, width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                      <Form.Item name="vmp4" label={<span style={{ fontFamily: FONT }}>VMP 4</span>}>
                        <InputNumber
                          decimalSeparator=","
                          style={{ fontFamily: FONT, width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            }
          />
        </Card>
      </Col>
    );
  };
  function mountChart(useCompactChart) {
    const formatWeekLabel = (load) =>
      useCompactChart ? `S${load}` : `Semana ${load}`;

    return data.map((item) => {
      const vmps = [item.vmp1, item.vmp2, item.vmp3, item.vmp4].filter(
        (item) => item != null
      );
      var vmpMax = null;
      if (vmps.length > 0) {
        vmpMax = Math.max(...vmps);
      }
      const vmpEsperada = planTraining[`vmp${item.load}`];
      return {
        load: formatWeekLabel(item.load),
        week: item.load,
        vmpEsperada: vmpEsperada,
        vmpAtual: vmpMax,
      };
    });
  }

  const useCompactChart = !isDesktop || data.length > 4;
  const evolutionChartData = mountChart(useCompactChart);
  const evolutionChartOptions = useCompactChart
    ? {
        height: isMobile ? 300 : 320,
        xAxisAngle: -40,
        xAxisFontSize: 11,
        yAxisFontSize: 11,
        xAxisHeight: 58,
        margin: { top: 8, right: 12, left: 0, bottom: 4 },
        barCategoryGap: "22%",
        minChartWidth: Math.max(data.length * 80, 320),
      }
    : undefined;

  const handeSave = () => {
    setLoadingData(true);
    const newValues = formUser.getFieldValue();

    const newData = data.map((item) => {
      if (item.id == editId.id) {
        return { ...item, ...newValues };
      } else {
        return item;
      }
    });
    const obj = {
      id: editId.id,
      vmp1: newValues.vmp1,
      vmp2: newValues.vmp2,
      vmp3: newValues.vmp3,
      vmp4: newValues.vmp4,
    };
    updateTraining(obj)
      .then(() => {
        notificationSucess();
        setData(newData);
        onClose();
        formUser.resetFields();
        setLoadingData(false);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  };
  function openAnotation(annotation) {
    formAnnotation.setFieldValue("userAnnotation", annotation);

    info({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Anotações do Treino
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formAnnotation} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userAnnotation">
                    <TextArea disabled={true} rows={8} className="annotation" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Fechar",
      onOk() {
        formAnnotation.resetFields();
      },
    });
  }

  return (
    <div className="managerial-evolution-drawer">
      <Spin spinning={loadingData}>
        <Row gutter={16} style={{ textAlign: "center", marginBottom: "30px" }}>
          <Col span={24}>
            <Avatar
              src={props.user?.img}
              icon={<UserRound size={isMobile ? 80 : 120} />}
              size={isMobile ? 80 : 120}
            />
          </Col>
        </Row>

        <Card
          id="card-table"
          className="card-table-list managerial-evolution-table"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ flex: 1 }}>
                <ChartBar
                  size={18}
                  style={{ marginBottom: "-4px", marginRight: "10px" }}
                />
                <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                  Treinos Realizados
                </Text>
              </div>
            </div>
          }
          bordered={false}
        >
          <ResponsiveDataList
            isMobile={isMobile}
            forceCardLayout
            cardVariant="metric"
            rowKey="id"
            columns={ColumnsChart()}
            dataSource={data}
            pagination={{ pageSize: 2, showSizeChanger: false }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </Card>
        <Row
          className="managerial-evolution-actions"
          style={{ margin: "12px 0" }}
          justify={isMobile ? "center" : "end"}
        >
          <Col xs={24} md="auto">
            <Button
              block={isMobile}
              style={{
                fontFamily: FONT,
                background: "#14B8A6",
                color: "#ffffff",
              }}
              onClick={() => setOpenComparation(true)}
            >
              Controle de Carga
            </Button>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: "15px" }}>
          <Col span={24} style={{ marginTop: "10px" }}>
            <Card
              className="managerial-evolution-chart-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <ArrowUpFromLine
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "14px", fontFamily: FONT }}>
                      Evolução VMP
                    </Text>
                  </div>
                </div>
              }
              style={{ width: "100%" }}
            >
              {chartBar(
                evolutionChartData,
                "load",
                "vmpEsperada",
                "vmpAtual",
                "VMP Esperada",
                "VMP Atual",
                10,
                <CustomTooltip />,
                evolutionChartOptions
              )}
            </Card>
          </Col>
        </Row>
      </Spin>
      <DrawerApp
        open={open}
        onClose={onClose}
        title={"Editar Treino"}
        body={<CardTraining row={editId} />}
        actionSave={handeSave}
        width={drawerWidth(isMobile, 40)}
      />
      <DrawerApp
        open={openComparation}
        onClose={onCloseComparation}
        title={"Histórico"}
        body={<FormLoadUserComparation userId={props.user?.id} />}
        size={"large"}
        width={drawerWidth(isMobile, 90)}
        isOnlyView={true}
      />
    </div>
  );
};
export default ManagerialChart;
